import React, { Component, Fragment } from 'react';
import {
    Input,
    Button,
    Row,
    Col,
    Label,
    InputGroup,
    InputGroupAddon,
    InputGroupText
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons'
import { CSVLink } from "react-csv";
import { isSaleOpportunityValid } from '../opportunityValidation';
// import OpportunitiesNotesForm from './OpportunitiesNotesForm';

class AddOpportunity extends Component {

    constructor(props) {
        super(props);
        

        this.state = {
            add: Boolean(props.embedded)
        };
    };

    formatDate = (dateStr) => {
        if (!dateStr || dateStr === '') return '';
        const date = new Date(dateStr);

        const month = date.getUTCMonth() + 1; // Months are 0-indexed
        const day = date.getUTCDate();
        const year = date.getUTCFullYear().toString().slice(-2); // Get last two digits of the year

        return `${month}/${day}/${year}`;
    }

    render() {
        if (this.state.add) {
            return (<>
                <Row>
                    <Col md={3}>
                        <Row className="mb-2">
                            <Col>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>WA</InputGroupText>
                                    </InputGroupAddon>
                                    <Input
                                        aria-label="WA number"
                                        placeholder="Number"
                                        name="waNumber"
                                        maxLength={100}
                                        value={this.props.newOpportunity.waNumber + ''}
                                        onChange={e => this.props.onChange(e)}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    placeholder="Opportunity Name"
                                    name="name"
                                    value={this.props.newOpportunity.name + ''}
                                    onChange={e => this.props.onChange(e)} />
                            </Col>
                        </Row>
                        {/* {this.props.contacts != null && this.props.contacts.length > 0 && */}
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="select"
                                    name="contactLinkedID"
                                    onChange={e => this.props.onChange(e)}
                                    value={this.props.newOpportunity.contactLinkedID}
                                    disabled={this.props.lockContact}
                                >
                                    <option value="">Contact</option>
                                    {this.props.contacts.map(contact => {
                                        if (contact.children != null && contact.children['Contact Name'] != null) {
                                            return (
                                                <option key={contact.linkedID} value={contact.linkedID}>
                                                    {contact.children['Contact Name']}
                                                    {!contact.active ? ' (Inactive)' : ''}
                                                </option>
                                            )
                                        } else {
                                            return null;
                                        }
                                    })}
                                </Input>
                            </Col>
                        </Row>
                        {/* } */}
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="date"
                                    name="date"
                                    value={String(this.props.newOpportunity.date).substring(0, 10) + ''}
                                    onChange={e => this.props.onChange(e)} />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="select"
                                    name="typeID"
                                    value={this.props.newOpportunity.typeID}
                                    onChange={e => this.props.onChange(e)}>
                                    <option value={0}>Type</option>
                                    {this.props.types.map(type => (
                                        <option key={type.ID} value={type.ID}>{type.Opportunity}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="select"
                                    name="statusID"
                                    value={this.props.newOpportunity.statusID}
                                    onChange={e => this.props.onChange(e)}>
                                    <option value={0}>Status</option>
                                    {this.props.selectedStatuses.map(selectedStatus => (
                                        <option key={selectedStatus.ID} value={selectedStatus.ID}>{selectedStatus.Opportunity}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="select"
                                    name="stageID"
                                    value={this.props.newOpportunity.stageID}
                                    onChange={e => this.props.onChange(e)}>
                                    <option value={0}>Stage</option>
                                    {this.props.stages.map(stage => (
                                        <option key={stage.ID} value={stage.ID}>{stage.Opportunity}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input type="select" name="sourceID" value={this.props.newOpportunity.sourceID || 0} onChange={e => this.props.onChange(e)}>
                                    <option value={0}>Source</option>
                                    {this.props.sources.map(source => <option key={source.ID} value={source.ID}>{source.Opportunity}</option>)}
                                </Input>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={3}>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="select"
                                    name="assigneeUserID"
                                    value={this.props.newOpportunity.assigneeUserID}
                                    onChange={e => this.props.onChange(e)}>
                                    <option value={0}>Assignee</option>
                                    {this.props.users.map(user => (
                                        <option key={user.Auth0} value={user.Auth0}>{user['Full Name']}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    placeholder="Assignee (Other)"
                                    name="assigneeUserOther"
                                    value={this.props.newOpportunity.assigneeUserOther + ''}
                                    onChange={e => this.props.onChange(e)} />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="select"
                                    name="salesRepUserID"
                                    value={this.props.newOpportunity.salesRepUserID}
                                    onChange={e => this.props.onChange(e)}>
                                    <option value={0}>Sales Rep</option>
                                    {this.props.users.map(user => (
                                        <option key={user.Auth0} value={user.Auth0}>{user['Full Name']}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    placeholder="Sales Rep (Other)"
                                    name="salesRepUserOther"
                                    value={this.props.newOpportunity.salesRepUserOther + ''}
                                    onChange={e => this.props.onChange(e)} />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    placeholder="Opportunity Amount"
                                    name="opportunityAmount"
                                    value={this.props.newOpportunity.opportunityAmount != null ? this.props.newOpportunity.opportunityAmount : ''}
                                    onChange={e => this.props.onChange(e)} />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col className="pl-5">
                                <Label>
                                    <Input
                                        type="checkbox"
                                        name="active"
                                        checked={this.props.newOpportunity.active}
                                        onChange={e => this.props.onChange(e)} />
                                    Active</Label>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={3}>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="select"
                                    name="maintenanceRequirementStatus"
                                    value={this.props.newOpportunity.maintenanceRequirementStatus}
                                    onChange={e => this.props.onChange(e)}>
                                    <option value="">Maint. Requirement Status</option>
                                    <option>Maint - Optional</option>
                                    <option>Maint - Mandatory</option>
                                    <option>Maint - Not Offered</option>
                                </Input>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="select"
                                    name="maintenanceAcceptanceStatus"
                                    value={this.props.newOpportunity.maintenanceAcceptanceStatus}
                                    onChange={e => this.props.onChange(e)}>
                                    <option value="">Maint. Acceptance Status</option>
                                    <option>Maint - N/A</option>
                                    <option>Maint - Offered</option>
                                    <option>Maint - Accepted</option>
                                    <option>Maint - Declined</option>
                                </Input>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="date"
                                    name="maintenanceEndDate"
                                    value={this.props.newOpportunity.maintenanceEndDate != null ? this.props.newOpportunity.maintenanceEndDate : ''}
                                    onChange={e => this.props.onChange(e)} />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    placeholder='Maintenance Notes'
                                    type="textarea"
                                    rows={10}
                                    name="maintenanceNotes"
                                    value={this.props.newOpportunity.maintenanceNotes}
                                    onChange={e => this.props.onChange(e)}
                                />
                            </Col>
                        </Row>
                        {/* <Row className="mb-2">
                            <Col>
                                <Input
                                    placeholder='Commission Notes'
                                    type="textarea"
                                    rows={3}
                                    name="commissionNotes"
                                    value={this.props.newOpportunity.CommissionNotes}
                                    onChange={e => this.props.onChange(e)}
                                />
                            </Col>
                        </Row> */}
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    placeholder='Next Steps'
                                    name="nextSteps"
                                    value={this.props.newOpportunity.nextSteps}
                                    onChange={e => this.props.onChange(e)}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col className="text-right mt-2">
                                <Button
                                    disabled={this.props.saving || !isSaleOpportunityValid(this.props.newOpportunity, {
                                        requireCompany: this.props.requireCompany,
                                        requireContact: this.props.requireContact
                                    })}
                                    className="mx-1"
                                    color="success"
                                    onClick={() => this.props.embedded
                                        ? this.props.handleAdd()
                                        : this.setState({ add: false }, () => this.props.handleAdd())}
                                    title="Add Opportunity"
                                >
                                    <FontAwesomeIcon icon={faPlus} />
                                </Button>
                                <Button className="mx-1" color="secondary" onClick={() => this.props.embedded
                                    ? this.props.handleCancel()
                                    : this.setState({ add: false }, () => this.props.handleCancel())} title="Cancel">
                                    <FontAwesomeIcon icon={faTimes} />
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={3} className='border-left border-dark'>
                        <Row className="mb-2">
                            <Col>
                                <Row>
                                    <Col className='pr-2'>
                                        <Input
                                            type="date"
                                            name="salesActivityDate"
                                            // value={this.state.date}
                                            // onChange={(e) => this.setState({ date: e.target.value })}
                                            value={this.props.newOpportunity.salesActivityDate}
                                    o       onChange={e => this.props.onChange(e)}
                                        />
                                    </Col>
                                    <Col className='pl-0'>
                                        {this.props.addCategoryCommentsArray.map(row => {
                                            switch (row.validation) {
                                                case "list":
                                                    return (
                                                        <Fragment key={row.ID}>
                                                            <Input type="select"
                                                                name="salesActivityTypeID"
                                                                value={this.props.newOpportunity.salesActivityTypeID}
                                                                onChange={e => this.props.onChange(e)}
                                                                // onChange={(e) => this.setState({ typeID: parseInt(e.target.value) })}
                                                            >
                                                                <option value="0">ACTIVITY</option>
                                                                {row.list != null && row.list
                                                                    .filter(item => item.longDescription !== 'Other')
                                                                    .map(item => (
                                                                        <option key={item.ID} value={item.ID}>{item.longDescription}</option>
                                                                    ))}
                                                            </Input>
                                                        </Fragment>
                                                    )
                                                default:
                                                    return (
                                                        <></>
                                                    )
                                            }
                                        })}
                                    </Col>
                                </Row>
                                <Row className='mt-2'>
                                    <Col>
                                        <Input
                                            type="textarea"
                                            name="salesActivityNotes"
                                            rows={15}
                                            placeholder='Sales Opportunity Note'
                                            value={this.props.newOpportunity.salesActivityNotes}
                                            onChange={e => this.props.onChange(e)}
                                            // onChange={(e) => this.setState({ notes: e.target.value })}
                                        />
                                    </Col>
                                </Row>
                                {/* <Row className='mt-2'>
                                    <Col>
                                        <Button
                                            color="success"
                                            onClick={this.addNote}
                                        >
                                            Save
                                        </Button>
                                        <Button
                                            color="secondary"
                                            className='ml-2'
                                            onClick={() => this.setState({ add: false })}
                                        >
                                            Cancel
                                        </Button>
                                    </Col>
                                </Row> */}
                                {/* <OpportunitiesNotesForm {...this.props} /> */}
                            </Col>
                        </Row>
                        {/* <Row className="mb-2">
                            <Col>
                                <Input
                                    placeholder='Notes'
                                    type="textarea"
                                    rows={4}
                                    name="notes"
                                    value={this.props.newOpportunity.notes}
                                    onChange={e => this.props.onChange(e)}
                                />
                            </Col>
                        </Row> */}

                    </Col>
                </Row>



            </>
            )
        } else if (!this.props.embedded) {
            return (
                <Row>
                    <Col>
                        <Button onClick={() => { this.props.displayCategories({ target: { value: 27 } }); this.setState({ add: true })}} color="primary">Add {this.props.type}</Button>
                    </Col>
                    {this.props.opportunities.length > 0 &&
                        <>
                            <Col md={2} className="text-right">
                                <Label>
                                    <Label>
                                        <Input
                                            type="checkbox"
                                            name="active"
                                            checked={this.props.showInactive}
                                            onChange={this.props.showHideInactive} />
                                        Toggle Inactive</Label>
                                </Label>
                            </Col>
                            <Col md={2} className="text-right">
                                <CSVLink className="btn btn-primary"
                                    headers={[
                                        'Opportunity Name',
                                        'WA#',
                                        'Date',
                                        'Amount',
                                        'Contact Name',
                                        'Type',
                                        'Status',
                                        'Stage',
                                        'Assignee',
                                        'Sales Rep',
                                        'Maint. Requirement Status',
                                        'Maint. Acceptance Status',
                                        'Maint. End Date',
                                        'Maint. Notes',
                                        'Maint. Next Steps',
                                        'Commission Notes'
                                    ]}
                                    filename='Sales Opportunities Export.csv'
                                    data={
                                        this.props.opportunities.map(row => [
                                            row['Sales Opportunity Name'],
                                            row['WA#'] || `WA${row.ID}`,
                                            this.formatDate(row['Sales Opportunity Date'] || ''),
                                            row['Opportunity Amount'] ? new Intl.NumberFormat('en-US', {
                                                style: 'currency',
                                                currency: 'USD',
                                            }).format(row['Opportunity Amount']) : '',
                                            row['Contact Name'],
                                            row['Type Description'],
                                            row['Status'],
                                            row['Stage'],
                                            row['Opportunity Assignee User Other'] || `${row['Opportunity Assignee User First Name'] || ''} ${row['Opportunity Assignee User Last Name'] || ''}`,
                                            row['Opportunity Assignee Rep User Other '] || `${row['Opportunity Assignee Rep User First Name'] || ''} ${row['Opportunity Assignee Rep User Last Name'] || ''}`,
                                            row['MaintenanceRequirementStatus'],
                                            row['MaintenanceAcceptanceStatus'],
                                            this.formatDate(row['MaintenanceEndDate'] || ''),
                                            row['MaintenanceNotes'],
                                            row['MaintenanceNextSteps'],
                                            row['CommissionNotes']
                                        ])
                                    }>Export Opportunties CSV</CSVLink>
                            </Col>
                        </>}
                </Row>

            )
        }
        return null;
    }
}

export default AddOpportunity;
